﻿import { BaseEditor } from './base-editor';
import { IForm } from '../interface/form';
import { AsyncValidatorFn, ValidatorFn } from '../types/validator-fn';
import { IEditor } from '../interface/editor';

export const TextareaEditorTagName = 't-textarea';

export function createTextareaEditor(form: IForm,
    name: string,
    element: HTMLElement,
    validators: ValidatorFn[],
    asyncValidators: AsyncValidatorFn[]): IEditor {
    return new TTextareaEditor(form, name, element, validators, asyncValidators);
}

export class TTextareaEditor extends BaseEditor<string> {
    inputElement: HTMLTextAreaElement = null!;

    constructor(
        form: IForm,
        name: string,
        element: HTMLElement,
        validators: ValidatorFn[],
        asyncValidators: AsyncValidatorFn[]) {
        super(form, name, element, validators, asyncValidators);

        const ele = element.querySelector<HTMLTextAreaElement>('textarea.form-control');
        if (!ele) {
            throw new Error(`Invalid DOM of field ${name}`);
        }

        this.inputElement = ele;
        this.inputElement.addEventListener('change', (ev: Event) => {
            this.reValidate();
            this.notifyChanges(this.value);
        });
        this.inputElement.addEventListener('keyup', (ev: Event) => {
            this.reValidate();
            this.notifyChanges(this.value);
        });

    }

    get value(): string {
        return this.inputElement.value;
    }
    set value(value: string) {
        this.inputElement.value = value;
    }

    setDisabled(disabled: boolean): void {
        this.inputElement.disabled = disabled;
        this.setDisabledInternal(disabled);
    }

    setFocus():void {
        this.inputElement.focus();
    }
}